
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import auth from '@/modules/Auth'
import session from '@/modules/Session'

export default {
  directives: {
    TransferDom
  },

  components: {
    Group,
    Cell,
    XHeader,
    Confirm,
    Loading,
    session
  },

  data () {
    return {
      userIdToSwitch: null,
      showConfirmSwitching: false
    }
  },

  computed: {
    otherUsers () {
      return this.profile.users.filter(
        (user) => user.id !== this.$store.state.user.id)
    },
    user () {
      return this.$store.state.user
    },
    profile () {
      return this.$store.state.profile
    },
    userToSwitch () {
      const self = this
      return this.otherUsers.find((user) => user.id === self.userIdToSwitch)
    }
  },

  methods: {
    requestToSwitch (userId) {
      this.userIdToSwitch = userId
      this.showConfirmSwitching = true
    },
    switchUser (userId) {
      auth.switch(userId)
    },
    displayName (user) {
      return `${user.data.local_name}  ${user.username}`
    }
  },

  async mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings.vue